module.exports = __webpack_public_path__ + "img/sistema_museale.661caf8c.jpg";